import { Box, Stack, styled } from "@mui/material";

export const Section = styled(Stack)(({ theme }) => (props) => ({
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    padding: '32px 48px',
    [theme.breakpoints.down('md')]: {
        padding: '24px  24px'
    },
    [theme.breakpoints.down('sm')]: {
        padding: '12px  12px ',
    },
    [theme.breakpoints.down('xs')]: {
        padding: '12px 6px',
    },
}))
export const RightSection = styled(Box)(({ theme }) => (props) => ({
    width: '70%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    [theme.breakpoints.down('lg')]: {
        width: '60%'
    },
    [theme.breakpoints.down('md')]: {
        width: '100%'
    }
}))
export const LeftSection = styled(Box)(({ theme }) => (props) => ({
    width: '30%',
    background: '#0056D21A',
    padding: '48px',
    paddingBottom: '20px',
    marginRight: '48px',
    borderRadius: theme.shape.borderRadius,
    display: 'flex',
    alignItems: 'center',
    height: '55vh',
    justifyContent: 'center',
    [theme.breakpoints.down('lg')]: {
        width: '35%'
    },
    [theme.breakpoints.down('md')]: {
        display: 'none'
    }
}))
export const Images = styled('img')(({ theme }) => (props) => ({
    width: '250px',
    height: '250px',
    borderRadius: 'none'
}))
